<template>
  <div>
    <transition name="fade">
      <div v-if="visible" class="overlay" @click="closeDrawer"></div>
    </transition>

    <transition name="slide">
      <aside v-if="visible" class="drawer">
        <div class="drawer-container">
          <div class="drawer-header">
            <span style="display: flex; align-items: center; gap: 0.5rem">
              <button
                v-if="isDetailsView"
                @click="goBackToShipment"
                style="border: none; background-color: transparent"
              >
                <DrawerBack />
              </button>
              <span class="drawer-title">
                {{
                  isDetailsView
                    ? $t("container_details")
                    : $t("shipment_details")
                }}
              </span>
            </span>
            <button class="close" @click="closeDrawer">
              <img src="../assets/images/cancle.svg" />
            </button>
          </div>
          <div v-if="!isDetailsView">
            <div class="drawer-content">
              <div class="accordion" id="accordionExample">
                <div>
                  <div
                    @click="showShipment = !showShipment"
                    class="d-flex justify-content-between align-items-center cursor-pointer"
                  >
                    <span style="font-weight: 500; size: 12px">
                      {{ $t("shipping_details") }}</span
                    >

                    <span>
                      <DrawerArrow
                        v-if="showShipment"
                        style="transform: rotate(180deg)"
                      />
                      <DrawerArrow v-else />
                    </span>
                  </div>
                  <transition name="slide-accordion">
                    <div class="shippingDetails_card" v-if="showShipment">
                      <div>
                        <span> {{ $t("shipmemt-id") }} </span>
                        <span class="end"> {{ shipment.shipmentId }} </span>
                      </div>
                      <div>
                        <span> {{ $t("shipmemt-type") }} </span>
                        <span class="end text-capitalize">
                          {{ `${shipment.shipmentType} freight` }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("reference") }} </span>
                        <span class="end"> {{ shipment.reference }} </span>
                      </div>
                      <div v-if="shipment.vesselName">
                        <span> {{ $t("vessel-name") }}</span>
                        <span class="end"> {{ shipment.vesselName }} </span>
                      </div>
                      <div v-if="shipment.flightNumber">
                        <span> {{ $t("flight_number") }}</span>
                        <span class="end"> {{ shipment.flightNumber }} </span>
                      </div>
                      <div v-if="shipment.awb">
                        <span> {{ $t("awb") }}</span>
                        <span class="end"> {{ shipment.awb }} </span>
                      </div>

                      <div>
                        <span> {{ $t("loading-date") }} </span>
                        <span class="end">
                          {{ formatDate(shipment.loadingDate) }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("departure-date") }}</span>
                        <span class="end">
                          {{ formatDate(shipment.departureDate) }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("eta") }} </span>
                        <span class="end">
                          {{
                            calculateETA(shipment.departureDate, shipment.eta)
                          }}
                        </span>
                      </div>

                      <div>
                        <span> {{ $t("point-of-arrival") }} </span>
                        <span class="end"> {{ shipment.pointOfArrival }} </span>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>

            <div class="drawer-content">
              <div class="accordion" id="accordionExample">
                <div>
                  <div
                    @click="showOrigin = !showOrigin"
                    class="d-flex justify-content-between align-items-center cursor-pointer"
                  >
                    <span style="font-weight: 500; size: 12px">
                      {{ $t("origin_details") }}</span
                    >

                    <span>
                      <DrawerArrow
                        v-if="showOrigin"
                        style="transform: rotate(180deg)"
                      />
                      <DrawerArrow v-else />
                    </span>
                  </div>
                  <transition name="slide-accordion">
                    <div class="shippingDetails_card" v-if="showOrigin">
                      <div>
                        <span> {{ $t("name") }}</span>
                        <span class="end">
                          {{ shipment.originDetails.name }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("address") }} </span>
                        <span class="end" style="width: 180px">
                          {{ shipment.originDetails.address.name }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("region") }} </span>
                        <span class="end">
                          {{ shipment.originDetails.region }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("country") }} </span>
                        <span class="end">
                          {{ shipment.originDetails.country }}
                        </span>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>

            <div class="drawer-content">
              <div class="accordion" id="accordionExample">
                <div>
                  <div
                    @click="showDestination = !showDestination"
                    class="d-flex justify-content-between align-items-center cursor-pointer"
                  >
                    <span style="font-weight: 500; size: 12px">
                      {{ $t("destination_details") }}</span
                    >

                    <span>
                      <DrawerArrow
                        v-if="showDestination"
                        style="transform: rotate(180deg)"
                      />
                      <DrawerArrow v-else />
                    </span>
                  </div>
                  <transition name="slide-accordion">
                    <div class="shippingDetails_card" v-if="showDestination">
                      <div>
                        <span> {{ $t("name") }}</span>
                        <span class="end">
                          {{ shipment.destinationDetails.name }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("person-of-contact") }} </span>
                        <span class="end">
                          {{ shipment.destinationDetails.personOfContact }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("region") }} </span>
                        <span class="end">
                          {{ shipment.destinationDetails.region }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("country") }} </span>
                        <span class="end">
                          {{ shipment.destinationDetails.country }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("address") }} </span>
                        <span class="end" style="width: 180px">
                          {{
                            shipment.destinationDetails
                              ? shipment.destinationDetails.address.name
                              : "-"
                          }}
                        </span>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>

            <div
              class="card table-responsive"
              style="margin-top: 2rem; margin-bottom: 2rem"
            >
              <div
                id="zero_config_wrapper"
                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
                style="padding: 1rem"
              >
                <p style="font-weight: 500; font-size: 16px">
                  {{ $t("all_containers") }}
                </p>
                <div class="row" style="overflow: auto">
                  <div class="col-sm-12">
                    <table id="zero_config" class="table">
                      <thead class="data-table-bg">
                        <tr>
                          <th
                            v-for="(column, index) in tableColumns"
                            style="cursor: pointer; text-align: center"
                            :key="index"
                          >
                            {{ column[0] }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template>
                          <tr
                            v-for="(data, index) in shipment.containers"
                            :key="index"
                            style="cursor: pointer; text-align: center"
                            :class="{ 'data-table-bg': index % 2 !== 0 }"
                            @click="showContainerDetails(data)"
                          >
                            <td style="text-transform: capitalize">
                              {{ data.product }}
                            </td>
                            <td>{{ data.pallet }}</td>
                            <td>{{ data.containerNumber }}</td>
                            <td>
                              {{ data.assignedDevices.length }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isDetailsView && selectedContainer" class="drawer-content">
            <div class="drawer-content">
              <div class="accordion" id="accordionExample">
                <div>
                  <div
                    @click="showContainer = !showContainer"
                    class="d-flex justify-content-between align-items-center cursor-pointer"
                  >
                    <span style="font-weight: 500; size: 12px">
                      {{ $t("container_details") }}</span
                    >
                    <span>
                      <DrawerArrow
                        v-if="showContainer"
                        style="transform: rotate(180deg)"
                      />
                      <DrawerArrow v-else />
                    </span>
                  </div>
                  <transition name="slide-accordion">
                    <div class="shippingDetails_card" v-if="showContainer">
                      <div>
                        <span> {{ $t("container_number") }} </span>
                        <span class="end">
                          {{ selectedContainer.containerNumber }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("product") }} </span>
                        <span class="end">
                          {{ selectedContainer.product }}
                        </span>
                      </div>
                      <div>
                        <span> {{ $t("no-of-pallet") }} </span>
                        <span class="end">
                          {{ selectedContainer.pallet }}
                        </span>
                      </div>

                      <div>
                        <span> {{ $t("no-of-devices") }} </span>
                        <span class="end">
                          {{ selectedContainer.assignedDevices.length }}
                        </span>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <div class="drawer-content">
              <div>
                <div class="flex-header">
                  <div class="d-flex col-gap-1 align-items-end">
                    <div>
                      <p style="font-weight: 500; size: 12px" class="mb-1">
                        {{ $t("select_device") }}
                      </p>
                      <select
                        class="form-control"
                        name="device"
                        style="
                          width: 11rem;
                          cursor: pointer;
                          background-color: rgb(247 248 249) !important;
                          border-radius: 8px;
                          border: 1px solid rgba(183, 195, 205, 1);
                        "
                        v-model="activeDevice"
                      >
                        <option
                          v-for="device in selectedContainer.assignedDevices"
                          :key="device.id"
                          :value="device.id"
                        >
                          {{ device.name }}
                        </option>
                      </select>
                    </div>

                    <div>
                      <div class="inner-flexHeader">
                        <span class="gray-text"> {{ $t("deviceTag") }} </span>
                        <span> {{ singledevice.deviceTag }} </span>
                      </div>
                      <div class="inner-flexHeader">
                        <span class="gray-text"> {{ $t("imei_") }} </span>
                        <span> {{ singledevice.imei }} </span>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <router-link
                      style="
                        font-weight: 500;
                        size: 12px;
                        text-decoration: none;
                      "
                      class="mb-1 text-primary"
                      :to="`/devices/${activeDevice}/details`"
                    >
                      {{ $t("go_to_device_details") }}
                      <ArrowRightColored
                        style="stroke: #213e7a; margin-left: 5px"
                      />
                    </router-link>
                    <!-- Date Picker -->
                    <date-range-picker
                      v-model="dateRange"
                      time-picker
                      :always-show-calendars="true"
                      :max-date="endDateData"
                      :min-date="shipment.departureDate"
                      @update="update"
                      :show-week-numbers="false"
                      auto-apply
                      :ranges="false"
                      :opens="'left'"
                      control-container-class="control-container"
                    ></date-range-picker>
                  </div>
                </div>
              </div>
            </div>

            <div class="drawer-content">
              <span style="font-weight: 500; size: 12px">
                {{ $t("maps") }}</span
              >
              <div style="margin-top: 1rem">
                <map-direction
                  :start="originLatLng"
                  :end="destinationLatLng"
                  :height="'15rem'"
                  @isLoading="handleLoading"
                />
              </div>
            </div>

            <div class="drawer-content" style="margin-bottom: 2rem">
              <span style="font-weight: 500; size: 12px">
                {{ $t("temperature-humidity") }}</span
              >

              <div
                class="shippingDetails_card"
                style="padding-left: 0; padding-right: 0"
              >
                <div
                  class="d-flex justify-content-space-around col-md-10 col-lg-6 mx-auto"
                  style="align-content: center"
                >
                  <div class="btn-container">
                    <button
                      @click="
                        tempGraph = true;
                        humiGraph = false;
                      "
                      :disabled="tempGraph == true"
                      id="graphselect"
                      style="font-size: 12px; padding: 4px 15px"
                    >
                      {{ $t("temp") }}
                    </button>
                  </div>
                  <div class="btn-container">
                    <button
                      @click="
                        tempGraph = false;
                        humiGraph = true;
                      "
                      :disabled="tempGraph == false"
                      id="graphselect"
                      style="font-size: 12px; padding: 4px 15px"
                    >
                      {{ $t("humid") }}
                    </button>
                  </div>
                </div>
                <div class="w-100">
                  <CombinedChart
                    :tempGraph="tempGraph"
                    :humiGraph="humiGraph"
                    :stats="devicehistoryChart"
                    :title="singledevice.settings.name"
                    :hasTemp2="hasTemp2"
                    outCnvBaseFontSize="11"
                    captionFontSize="14"
                    subcaptionFontSize="12"
                    yAxisNameFontSize="12"
                    xAxisNameFontSize="12"
                    legendIconScale="1"
                    legendItemFontSize="12"
                    :height="`400`"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </transition>
  </div>
</template>

<script>
import moment from "moment";
import MapDirection from "../views/Dispatch/AddShipment/MapDirection.vue";
import CombinedChart from "./Devices/CombinedChart.vue";
import { mapActions, mapGetters } from "vuex";
import ArrowRightColored from "../components/Iconsvg/ArrowRightColored.vue";

import DrawerArrow from "./Iconsvg/DrawerArrow.vue";

import DrawerBack from "./Iconsvg/DrawerBack.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  components: {
    MapDirection,
    CombinedChart,
    ArrowRightColored,
    DrawerArrow,
    DrawerBack,
    DateRangePicker,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    shipment: Object,
  },
  data() {
    return {
      activeDevice: "",
      test: [],
      humiGraph: false,
      tempGraph: true,
      showShipment: false,
      showOrigin: false,
      showDestination: false,
      isDetailsView: false,
      showContainer: true,
      selectedContainer: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      devicehistoryChart: [],
    };
  },
  methods: {
    ...mapActions(["getDeviceHistoryChart", "fetchDeviceDetails"]),
    showContainerDetails(container) {
      this.selectedContainer = container;
      console.log(this.selectedContainer);
      this.isDetailsView = true;
    },
    goBackToShipment() {
      this.isDetailsView = false;
      this.selectedContainer = null;
    },
    closeDrawer() {
      this.$emit("update:visible", false);
      this.isDetailsView = false;
      this.activeDevice = "";
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.devicehistoryChart = [];
    },
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "-";
    },

    calculateETA(startDate, endDate) {
      const start = moment(startDate);
      const end = moment(endDate);

      const duration = moment.duration(end.diff(start));
      const totalHours = duration.asHours();

      if (totalHours >= 24) {
        const days = Math.floor(duration.asDays());
        return days === 1 ? `${days} Day` : `${days} Days`;
      } else {
        const hours = Math.floor(totalHours);
        return hours === 1 ? `${hours} Hour` : `${hours} Hours`;
      }
    },
    handleLoading(isLoading) {
      this.$emit("isLoading", isLoading);
    },
    fetchDeviceDetailsById() {
      if (this.visible) {
        const period = {
          device: this.activeDevice,
        };

        const params = {
          ...this.dateRange,
          filterOperator: "and",
        };
        this.$emit("isLoading", true);
        this.getDeviceHistoryChart({ period, params }).then((res) => {
          this.devicehistoryChart = res.data.payload.data;
        });

        this.fetchDeviceDetails({ device_id: this.activeDevice }).then((res) =>
          this.$emit("isLoading", false).catch((err) =>
            this.$emit("isLoading", false)
          )
        );
      }
    },
    update({ endDate, startDate }) {
      let period = {
        startDate: startDate ? moment(startDate).format() : undefined,
        endDate: endDate ? moment(endDate).format() : undefined,
      };

      this.dateRange = period;
      this.fetchDeviceDetailsById();
    },
  },
  computed: {
    ...mapGetters(["singledevice"]),
    hasTemp2() {
      if (typeof this.singledevice?.hasTemp2 === "boolean") {
        return this.singledevice.hasTemp2;
      }
      if (Array.isArray(this.devicehistoryChart)) {
        return this.devicehistoryChart.some(
          (reading) => reading && reading.temperature2 != null
        );
      }
      return false;
    },
    tableColumns() {
      return [
        [this.$t("product"), "column1"],
        [this.$t("no-of-pallet"), "column2"],
        [this.$t("container_number"), "column3"],
        [this.$t("no-of-devices"), "column4"],
      ];
    },
    originLatLng() {
      if (this.shipment.originDetails.address) {
        const { lat, lng } = this.shipment.originDetails.address;
        return { lat, lng };
      } else return null;
    },
    destinationLatLng() {
      if (
        this.shipment &&
        this.shipment.destinationDetails &&
        this.shipment.destinationDetails.address
      ) {
        const { lat, lng } = this.shipment.destinationDetails.address;
        return { lat, lng };
      }
      return null;
    },
    endDateData() {
      const now = new Date();
      const eta = new Date(this.shipment.eta);
      return eta < now ? eta : now;
    },
  },
  watch: {
    shipment: {
      handler(newVal) {
        this.selectedContainer = null;
        this.dateRange = {
          startDate: newVal.departureDate,
          endDate: this.endDateData,
        };
      },
      deep: true,
    },
    selectedContainer: {
      handler() {
        if (
          this.selectedContainer &&
          this.selectedContainer.assignedDevices &&
          this.selectedContainer.assignedDevices.length > 0
        ) {
          this.activeDevice = this.selectedContainer.assignedDevices[0].id;
        }
      },
      deep: true,
    },
    activeDevice() {
      if (this.visible) this.fetchDeviceDetailsById();
    },
  },
};
</script>

<style>
.overlay {
  position: fixed;
  width: 100vw;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 5000;
}

.drawer {
  position: fixed;
  right: 0;
  top: 0;
  width: 60vw;
  height: 100vh;
  background-color: rgba(247, 248, 249, 1);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  z-index: 5000;
  overflow-x: scroll;
}

.drawer-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 2rem;
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.drawer-title {
  font-size: 20px;
  font-weight: 700;
}

.close {
  cursor: pointer;
}

.drawer-content {
  margin-top: 1.5rem;
}

.flex-header {
  display: flex;
  justify-content: space-between;
  gap: 0.8rem;
  margin-top: 0.4rem;
  font-weight: 14px;
  margin-top: 0.5rem;
  font-weight: 400;
}

.inner-flexHeader {
  display: flex;
  gap: 3rem;
  justify-content: space-between;
}

.gray-text {
  color: rgba(134, 147, 165, 1);
}

.shippingDetails_card {
  background-color: rgba(255, 255, 255, 1);
  padding: 1rem;
  border-radius: 16px;
  margin-top: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.end {
  text-align: end;
}

.shippingDetails_card > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 400;
}

/* Transition styles */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}

.slide-enter-to,
.slide-leave {
  transform: translateX(0);
}

/* Slide accordion transition */
.slide-accordion-enter-active,
.slide-accordion-leave-active {
  transition: max-height 0.3s ease-in-out, padding 0.3s ease-in-out;
}
.slide-accordion-enter,
.slide-accordion-leave-to {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
}
.slide-accordion-enter-to,
.slide-accordion-leave {
  max-height: 100vh;
  padding-top: 1rem; /* Adjust according to your padding */
  padding-bottom: 1rem; /* Adjust according to your padding */
  overflow: hidden;
}
.slide-accordion-enter-active {
  transition-timing-function: ease-out;
}
.slide-accordion-leave-active {
  transition-timing-function: ease-in;
}

@media (max-width: 480px) {
  .drawer {
    width: 90vw;
  }

  .flex-header {
    flex-direction: column;
  }
}

@media (min-width: 481px) and (max-width: 767px) {
  .drawer {
    width: 82vw;
  }

  .flex-header {
    flex-direction: column;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .drawer {
    width: 65vw;
  }
}

.control-container {
  border-radius: 8px;
  border: 1px solid rgb(183, 195, 205);
  padding: 0.65rem 0.75rem;
}
</style>
